import React from "react";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className="relative min-h-[100vh] flex items-end pt-24 overflow-hidden" data-testid="hero-section">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_postpartum-care-7/artifacts/67i70ojz_tnJSjXXNdtD2ODZ8Bk0mw_auJGB8rE_00001%20%281%29.jpg"
          alt="Babyfüsschen mit Gänseblümchen auf weicher Decke"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-mask" />
      </div>

      <div className="relative max-w-7xl mx-auto w-full px-6 sm:px-10 lg:px-16 pb-16 sm:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.2, 0.9, 0.3, 1] }}
            >
              <p className="text-xs sm:text-sm tracking-[0.25em] uppercase text-[#A66B56] font-semibold mb-6">Wochenbettbetreuung · Neuenkirch & Sempachersee</p>
              <h1 className="font-display text-[40px] sm:text-[60px] lg:text-[70px] leading-[1.0] text-[#2A332C]">
                für einen sicheren und <br />
                <span className="font-display-italic text-[#A66B56]">entspannten Start</span> ins Leben.
              </h1>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.25 }}
            className="lg:col-span-4 lg:pb-4"
          >
            <p className="text-[#2A332C]/80 text-lg leading-relaxed max-w-sm">
              Mit Fachkompetenz und Einfühlungsvermögen begleite ich euch durch die erste Zeit mit eurem Baby.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a href="#anmeldung" className="btn-primary" data-testid="hero-cta-anmeldung">
                Anmelden
              </a>
              <a href="#ueber-mich" className="btn-outline" data-testid="hero-cta-ueber-mich">
                Mehr über mich
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
